import React, { Component } from "react";
import { Icon, Step, Grid } from "semantic-ui-react";
import EnrollmentPersonalInformation from "./EnrollmentPersonalInformation";
import EnrollmentContactDetails from "./EnrollmentContactDetails";
import EnrollmentOtherDetails from "./EnrollmentOtherDetails";
import PrevSchoolDetails from "./PrevSchoolDetails";
import EnrollmentDetails from "./EnrollmentDetails";
import Confirm from "./Confirm";
import Success from "./Success";

import axios from "axios";
import upperCase from "upper-case";

const changeCase = {
  upperCase,
};

const toTitleCase = (str) => {
  if (!str) return "";

  // Handle multi-word names
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => {
      // Capitalize first letter of each word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
};

export class ApplicantForm extends Component {
  state = {
    step: 1,
    firstName: "",
    middleName: "",
    lastName: "",
    extensionName: "",
    birthDate: "",
    gender: "",
    address: "",
    nickName: "",
    email: "",
    lrn: "",
    studentNumber: "",
    religion: "",
    placeOfBirth: "",
    mobile1: "",
    mobile2: "",
    contactPerson: "",
    contactPersonNumber: "",
    contactPersonAddress: "",
    guardianName: "",
    guardianNumber: "",
    guardianAddress: "",
    guardianOccupation: "",
    guardianOfficeAddress: "",
    beenHospitalized: false,
    hospitalReason: "",
    medicalHistory: "",
    prevSchoolName: "",
    prevSchoolAddress: "",
    file: "",
    filename: "",
    gradeFilename: "",
    applicationType: "",
    gradeLevel: "",
    paymentSchedule: "",
    applicantNumber: "",
    appNumber: "",
    enrollmentFile: null,
    gradeFile: null,
    mother: "",
    father: "",
    motherReason: "",
    ethnicity: "",
    motherTounge: "",
    languages: "",
  };

  componentDidMount() {
    console.log("ApplicantForm mounted with props:", this.props);

    // If student data is provided (for old students), populate the form
    if (this.props.student && this.props.applicationType === "old") {
      console.log(
        "Auto-populating form with student data:",
        this.props.student
      );

      const student = this.props.student;

      this.setState(
        {
          firstName: toTitleCase(student.firstName) || "",
          middleName: toTitleCase(student.middleName) || "",
          lastName: toTitleCase(student.lastName) || "",
          extensionName: student.extensionName || "",
          birthDate: student.birthDate || "",
          gender: student.gender || "",
          address: student.address || "",
          nickName: student.nickName || "",
          email: student.email || "",
          lrn: student.lrn || "",
          studentNumber: student.studentNumber || "",
          religion: student.religion || "",
          placeOfBirth: student.placeOfBirth || "",
          mobile1: student.mobile1 || "",
          mobile2: student.mobile2 || "",
          contactPerson: student.contactPerson || "",
          contactPersonNumber: student.contactPersonNumber || "",
          contactPersonAddress: student.contactPersonAddress || "",
          guardianName: student.guardianName || "",
          guardianNumber: student.guardianNumber || "",
          guardianAddress: student.guardianAddress || "",
          guardianOccupation: student.guardianOccupation || "",
          guardianOfficeAddress: student.guardianOfficeAddress || "",
          beenHospitalized: student.beenHospitalized || false,
          hospitalReason: student.hospitalReason || "",
          medicalHistory: student.medicalHistory || "",
          mother: student.mother || "",
          father: student.father || "",
          motherReason: student.motherReason || "",
          ethnicity: student.ethnicity || "",
          motherTounge: student.motherTounge || "",
          languages: student.languages || "",
          // Set grade level to the next level if available
          gradeLevel: this.props.nextGradeLevel || "",
        },
        () => {
          console.log("State updated with student data:", this.state);
        }
      );
    }
  }

  componentDidUpdate(prevProps) {
    // Check if student prop has changed from null to a value
    if (
      !prevProps.student &&
      this.props.student &&
      this.props.applicationType === "old"
    ) {
      console.log("Student data received in update:", this.props.student);

      const student = this.props.student;

      this.setState({
        firstName: toTitleCase(student.firstName) || "",
        middleName: toTitleCase(student.middleName) || "",
        lastName: toTitleCase(student.lastName) || "",
        extensionName: student.extensionName || "",
        birthDate: student.birthDate || "",
        gender: student.gender || "",
        address: student.address || "",
        nickName: student.nickName || "",
        email: student.email || "",
        lrn: student.lrn || "",
        studentNumber: student.studentNumber || "",
        religion: student.religion || "",
        placeOfBirth: student.placeOfBirth || "",
        mobile1: student.mobile1 || "",
        mobile2: student.mobile2 || "",
        contactPerson: student.contactPerson || "",
        contactPersonNumber: student.contactPersonNumber || "",
        contactPersonAddress: student.contactPersonAddress || "",
        guardianName: student.guardianName || "",
        guardianNumber: student.guardianNumber || "",
        guardianAddress: student.guardianAddress || "",
        guardianOccupation: student.guardianOccupation || "",
        guardianOfficeAddress: student.guardianOfficeAddress || "",
        beenHospitalized: student.beenHospitalized || false,
        hospitalReason: student.hospitalReason || "",
        medicalHistory: student.medicalHistory || "",
        mother: student.mother || "",
        father: student.father || "",
        motherReason: student.motherReason || "",
        ethnicity: student.ethnicity || "",
        motherTounge: student.motherTounge || "",
        languages: student.languages || "",
        gradeLevel: this.props.nextGradeLevel || "",
      });
    }
  }

  // Proceed to next step
  nextStep = () => {
    const { step } = this.state;
    if (step === 4) {
      if (this.props.applicationType === "old") {
        this.setState({
          step: step + 2,
        });
      } else {
        this.setState({
          step: step + 1,
        });
      }
    } else {
      this.setState({
        step: step + 1,
      });
    }
  };

  // Go back to prev step
  prevStep = () => {
    const { step } = this.state;
    if (step === 6) {
      if (this.props.applicationType === "old") {
        this.setState({
          step: step - 2,
        });
      } else {
        this.setState({
          step: step - 1,
        });
      }
    } else {
      this.setState({
        step: step - 1,
      });
    }
  };

  handleChange = (e, { name, value }) => {
    // Apply title case formatting for name fields
    if (name === "firstName" || name === "lastName" || name === "middleName") {
      this.setState({ [name]: toTitleCase(value) });
    } else {
      this.setState({ [name]: value });
    }
  };

  toggleHospitalized = () =>
    this.setState((prevState) => ({
      beenHospitalized: !prevState.beenHospitalized,
    }));
  // toggleSubsidy = () => this.setState((prevState) => ({ withESCSubsidy: !prevState.withESCSubsidy }))
  // toggleVoucher = () => this.setState((prevState) => ({ withSHSVoucher: !prevState.withSHSVoucher }))

  handleSubmit = (data) => {
    // Always ensure applicationType is set correctly based on the current flow
    const applicationType = this.props.applicationType;

    // Create the data object with the correct applicationType
    const submissionData = {
      ...data,
      applicationType: applicationType, // Explicitly set from props to ensure it's correct
    };

    const url = process.env.REACT_APP_URL + "/applicants";
    axios
      .request({
        method: "post",
        url: url,
        data: submissionData,
      })
      .then((response) => {
        alert(`Enrollment form was successfully saved.`);
        this.getApplicant(response.data.applicantId, true);
        this.handleUploadGradeFile();
        if (this.state.enrollmentFile !== null) {
          this.handleUploadEnrollmentFile();
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
  };

  handleSendApplicantNumberEmail = (applicantNumber) => {
    const message = `
    Hi! Thank you for completing the SALIS Enrollment Form. Here is your Applicant Number: ${applicantNumber} for ${this.state.lastName}, ${this.state.firstName}. You can use this to track the status of your application.

    You will receive another email regarding the assessment of your application.

    If you have questions or queries don't hesitate to contact us at our FB Page or reply via this email.

    Regards,

    SALIS Enrollment Team
    `;
    const data = {
      to: this.state.email,
      subject: "SALIS Enrollment Applicant Number",
      message: message,
    };

    axios
      .request({
        method: "post",
        url: process.env.REACT_APP_URL + "/applicants/sendEmail",
        data: data,
      })
      .then((response) => {
        alert(`Email sent!`);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
  };

  handleUploadFileChange = (enrollmentFile) => {
    const { firstName, lastName, gradeLevel } = this.state;
    const fileType = enrollmentFile.type;
    const fileTypeArray = fileType.split("/");
    const type = fileTypeArray[1];
    const fileName = `${changeCase.upperCase(lastName)}-${changeCase.upperCase(
      firstName
    )}-${changeCase.upperCase(gradeLevel)}.${type}`;
    const file = new File([enrollmentFile], fileName, {
      type: enrollmentFile.type,
    });

    this.setState({ enrollmentFile: file, filename: fileName });
  };

  handleUploadGradeFileChange = (gradeFile) => {
    const { firstName, lastName } = this.state;
    const fileType = gradeFile.type;
    const fileTypeArray = fileType.split("/");
    const type = fileTypeArray[1];
    const fileName = `${changeCase.upperCase(lastName)}-${changeCase.upperCase(
      firstName
    )}-REPORTCARD.${type}`;
    const file = new File([gradeFile], fileName, { type: gradeFile.type });

    this.setState({ gradeFile: file, gradeFilename: fileName });
  };

  handleUploadEnrollmentFile = () => {
    const url = process.env.REACT_APP_URL + "/assets/upload?module=enrollment";
    let fileData = new FormData();
    fileData.append("filePath", this.state.enrollmentFile);
    axios
      .request({
        method: "post",
        url: url,
        data: fileData,
      })
      .then((response) => {
        alert(`Requirements was successfully saved.`);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
  };

  handleUploadGradeFile = () => {
    const url = process.env.REACT_APP_URL + "/assets/upload?module=reportCard";
    let fileData = new FormData();
    fileData.append("filePath", this.state.gradeFile);
    axios
      .request({
        method: "post",
        url: url,
        data: fileData,
      })
      .then((response) => {
        alert(`Report card was successfully saved.`);
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
  };

  getApplicant = (id, fromSubmit) => {
    const url = process.env.REACT_APP_URL + "/applicants/" + id;
    axios
      .request({
        method: "get",
        url: url,
      })
      .then((response) => {
        if (fromSubmit) {
          this.handleSendApplicantNumberEmail(response.data.appNumber);
        }
        this.setState({
          applicantNumber: response.data.applicantNumber,
          appNumber: response.data.appNumber,
        });
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          alert(`${error.response.data.error.message}`);
        } else if (error.request) {
          alert(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          alert("Error. Please contact your administrator for assistance.");
        }
      });
  };

  renderSteps = () => {
    const { step } = this.state;
    return (
      <Grid style={{ marginBottom: "2em" }} textAlign="center">
        <Step.Group style={{ padding: 0 }} size="mini">
          <Step
            active={step === 1 ? true : false}
            onClick={() => this.setState({ step: 1 })}
          >
            <Icon name="user" />
            <Step.Content>
              <Step.Title>Personal Information</Step.Title>
            </Step.Content>
          </Step>
          <Step
            active={step === 2 ? true : false}
            onClick={() => this.setState({ step: 2 })}
          >
            <Icon name="phone" />
            <Step.Content>
              <Step.Title>Contact Details</Step.Title>
            </Step.Content>
          </Step>

          <Step
            active={step === 3 ? true : false}
            onClick={() => this.setState({ step: 3 })}
          >
            <Icon name="list" />
            <Step.Content>
              <Step.Title>Other Details</Step.Title>
            </Step.Content>
          </Step>

          <Step
            active={step === 4 ? true : false}
            onClick={() => this.setState({ step: 4 })}
          >
            <Icon name="write" />
            <Step.Content>
              <Step.Title>Enrollment Details</Step.Title>
            </Step.Content>
          </Step>

          {this.props.applicationType === "new" && (
            <Step
              active={step === 5 ? true : false}
              onClick={() => this.setState({ step: 5 })}
            >
              <Icon name="book" />
              <Step.Content>
                <Step.Title>New Student Requirements</Step.Title>
              </Step.Content>
            </Step>
          )}

          <Step
            active={step === 6 ? true : false}
            onClick={() => this.setState({ step: 6 })}
          >
            <Icon name="info" />
            <Step.Content>
              <Step.Title>Confirm</Step.Title>
            </Step.Content>
          </Step>
        </Step.Group>
      </Grid>
    );
  };

  render() {
    const { step } = this.state;

    const {
      firstName,
      middleName,
      lastName,
      extensionName,
      birthDate,
      gender,
      address,
      nickName,
      email,
      lrn,
      studentNumber,
      religion,
      placeOfBirth,
      mobile1,
      mobile2,
      contactPerson,
      contactPersonNumber,
      contactPersonAddress,
      guardianName,
      guardianNumber,
      guardianAddress,
      guardianOccupation,
      guardianOfficeAddress,
      beenHospitalized,
      hospitalReason,
      medicalHistory,
      prevSchoolName,
      prevSchoolAddress,
      file,
      filename,
      gradeFilename,
      gradeLevel,
      paymentSchedule,
      mother,
      father,
      motherReason,
      ethnicity,
      motherTounge,
      languages,
    } = this.state;

    const values = {
      firstName,
      middleName,
      lastName,
      extensionName,
      birthDate,
      gender,
      address,
      nickName,
      email,
      lrn,
      studentNumber,
      religion,
      placeOfBirth,
      mobile1,
      mobile2,
      contactPerson,
      contactPersonNumber,
      contactPersonAddress,
      guardianName,
      guardianNumber,
      guardianAddress,
      guardianOccupation,
      guardianOfficeAddress,
      beenHospitalized,
      hospitalReason,
      medicalHistory,
      prevSchoolName,
      prevSchoolAddress,
      file,
      filename,
      gradeFilename,
      gradeLevel,
      paymentSchedule,
      mother,
      father,
      motherReason,
      ethnicity,
      motherTounge,
      languages,
    };

    switch (step) {
      case 1:
        return (
          <>
            <EnrollmentPersonalInformation
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
              toggleHospitalized={this.toggleHospitalized}
            />
          </>
        );
      case 2:
        return (
          <>
            <EnrollmentContactDetails
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        );
      case 3:
        return (
          <>
            <EnrollmentOtherDetails
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        );
      case 4:
        return (
          <>
            <EnrollmentDetails
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              handleChange={this.handleChange}
              values={values}
              toggleSubsidy={this.toggleSubsidy}
              toggleVoucher={this.toggleVoucher}
            />
          </>
        );
      case 5:
        return (
          <>
            <PrevSchoolDetails
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              handleChange={this.handleChange}
              values={values}
              handleUploadFileChange={this.handleUploadFileChange}
              handleUploadGradeFileChange={this.handleUploadGradeFileChange}
            />
          </>
        );

      case 6:
        return (
          <>
            <Confirm
              applicationType={this.props.applicationType}
              enrollmentFile={this.state.enrollmentFile}
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              values={values}
              handleSubmit={this.handleSubmit}
            />
          </>
        );
      case 7:
        return (
          <>
            <Success
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              applicantNumber={this.state.applicantNumber}
              appNumber={this.state.appNumber}
              gradeLevel={this.state.gradeLevel}
              values={values}
            />
          </>
        );
      default:
        console.log("This is a multi-step form built with React.");
    }
  }
}

export default ApplicantForm;
